import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { images } from '../data/mockData';
import { getResponsiveImageUrl } from '../lib/imageOptimization';

const AboutPage = () => {
  const handleScheduleSession = () => {
    window.open('https://thewisdomnetwork.as.me/', '_blank', 'noopener noreferrer');
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Header Banner */}
      <section className="w-full">
        <img
          src={images.practitionerBanner}
          alt="The Wisdom Network"
          className="w-full h-64 object-cover"
          fetchPriority="high"
          decoding="async"
        />
      </section>

      {/* Our Mission Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-purple-800 mb-8 font-title">Our Mission</h2>
          <p className="text-lg text-purple-700 leading-relaxed font-body">
            Our mission is simple: to provide a trusted space for personal growth, healing, and transformation. 
            We understand the challenges of finding genuine spiritual guidance in today's fast-paced world. 
            That's why we've created a network where you can confidently find and connect with top-tier 
            practitioners who are dedicated to helping you achieve tangible, transformative results.
          </p>
        </div>
      </section>

      {/* About Us Section with Image */}
      <section className="py-20 bg-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Content */}
            <div>
              <div className="mb-8">
                <div className="flex items-center mb-8">
                  <div className="w-16 h-16 bg-purple-200 rounded-full flex items-center justify-center mr-4">
                    <div className="w-12 h-12 bg-purple-600 rounded-full"></div>
                  </div>
                  <h2 className="text-4xl font-bold text-purple-800 font-title">Our Story</h2>
                </div>
              </div>



              <p className="text-lg text-purple-700 leading-relaxed mb-8 font-body">
                At The Wisdom Network, we believe in the power of authentic spiritual and holistic guidance to 
                transform lives. Our platform connects you with the best certified spiritual life coaches, 
                herbalists, psychic readers, astrologers, healers, manifestation coaches, and other holistic 
                practitioners. Each of our practitioners is certified by Mystic University or other respected 
                institutions and thoroughly vetted to ensure they possess genuine skills and a deep commitment 
                to their craft.
              </p>

              <div className="text-center">
                <Button 
                  onClick={handleScheduleSession}
                  className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-xl font-body"
                >
                  SCHEDULE YOUR SESSION TODAY
                </Button>
              </div>
            </div>

            {/* Right Column - Image */}
            <div className="flex justify-center">
              <img
                src="https://static.wixstatic.com/media/8ea962_a34115c321dd4a87a7e27190415b9d50~mv2.png/v1/fill/w_782,h_1024,fp_0.48_0.36,q_90,enc_avif,quality_auto/8ea962_a34115c321dd4a87a7e27190415b9d50~mv2.png"
                alt="About Us"
                className="w-full max-w-md h-auto rounded-lg shadow-lg"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>


        </div>
      </section>

      {/* Why Choose The Wisdom Network Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-purple-800 mb-8 font-title">
              Why Choose The Wisdom Network?
            </h2>
            <div className="text-2xl text-purple-600 font-subtitle">
              Why Choose<span className="mx-4">The Wisdom Network?</span>Why Choose<span className="mx-4">The Wisdom Network?</span>Why Choose<span className="mx-4">The Wisdom Network?</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            <Card className="bg-purple-50 border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Certified Excellence:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  We only feature practitioners who are certified by Mystic University or other respected 
                  institutions and undergo rigorous verification for their authenticity and skills. You can 
                  trust that you are receiving guidance from the best.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-purple-50 border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Top Practitioners:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  Our network includes the best of the best, practitioners with real spiritual gifts and 
                  next-level skills. They are passionate about helping you achieve your goals and overcome challenges.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-purple-50 border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Results-Oriented:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  We focus on delivering real, measurable results. Our practitioners are committed to helping 
                  you make significant progress in your personal growth and healing journey.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-purple-50 border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Convenient and Accessible:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  With our easy-to-use online booking system, you can schedule sessions with your chosen 
                  practitioner at a time that suits you. We bring the expertise to you, wherever you are.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-purple-50 border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Diverse Services:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  From astrology to holistic healing, we offer a wide range of services to meet your unique 
                  needs. Whether you're seeking balance, healing, or personal growth, we have the right 
                  practitioner for you.
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            <Button 
              onClick={handleScheduleSession}
              className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-xl font-body"
            >
              SCHEDULE YOUR SESSION TODAY
            </Button>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="py-20 bg-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-purple-800 mb-8 font-title">Our Values</h2>
            <div className="text-2xl text-purple-600 font-subtitle">
              Our Values<span className="mx-4">Our Values</span>Our Values
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <Card className="bg-white border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Authenticity:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  We prioritize genuine wisdom and real spiritual gifts. Every practitioner on our platform 
                  is verified for their authenticity and commitment to their practice.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Excellence:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  We are dedicated to maintaining the highest standards of quality and service. Our practitioners 
                  are not just skilled; they are the best in their fields.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Transformation:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  We believe in the power of holistic and spiritual practices to create meaningful change in 
                  people's lives. Our goal is to help you achieve powerful, lasting transformations.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white border border-purple-200 hover:border-purple-400 transition-all duration-300">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-bold text-purple-800 mb-4 font-subtitle">Network:</h3>
                <p className="text-purple-700 leading-relaxed font-body">
                  We foster a network of top practitioners who are dedicated to delivering exceptional guidance 
                  and support. We are here to support you every step of the way.
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            <Button 
              onClick={handleScheduleSession}
              className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-xl font-body"
            >
              SCHEDULE YOUR SESSION TODAY
            </Button>
          </div>
        </div>
      </section>

      {/* Our Story - Founder Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Founder Image */}
            <div className="flex justify-center">
              <img
                src="https://static.wixstatic.com/media/8ea962_25394eceac804391af3ed5e32098fb4f~mv2.jpg/v1/crop/x_410,y_213,w_1707,h_1508/fill/w_147,h_130,al_c,q_80,usm_0.66_1.00_0.01,blur_2,enc_avif,quality_auto/8ea962_25394eceac804391af3ed5e32098fb4f~mv2.jpg"
                alt="Monica Bey - The Divine Mother"
                className="w-40 h-36 rounded-lg shadow-lg object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>

            {/* Right Column - Story Content */}
            <div>
              <h2 className="text-4xl font-bold text-purple-800 mb-8 font-title">Our Story</h2>
              <p className="text-lg text-purple-700 leading-relaxed font-body">
                The Wisdom Network was founded by Monica Bey, also known as The Divine Mother, a visionary 
                Spiritual Leader and Metaphysical Teacher with a strong presence in the spiritual and holistic 
                community. Monica saw a critical need for real practitioners who can drive real change and 
                transformation. Too often, people suffer longer than they need to because they struggle to 
                find authentic and effective spiritual guidance. Monica created The Wisdom Network to bring 
                together the most skilled and genuine practitioners, ensuring that everyone can access the 
                highest quality of holistic and spiritual services.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Branding Section */}
      <section className="py-16 bg-purple-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-6">
            <img
              src={getResponsiveImageUrl(images.spiritual, { width: 600 })}
              alt="The Wisdom Network"
              className="w-32 h-20 mx-auto rounded-lg object-cover shadow-lg"
              loading="lazy"
              decoding="async"
            />
          </div>

          <h2 className="text-3xl font-bold text-transparent bg-gradient-to-r from-yellow-400 to-yellow-300 bg-clip-text mb-4 font-title">
            THE WISDOM NETWORK:
          </h2>
          
          <p className="text-xl text-yellow-200 font-semibold font-subtitle">
            VERIFIED WISDOM, POWERFUL TRANSFORMATIONS
          </p>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;